<div class="payment-pending-container">
  <div *ngIf="!paymentPendingTimerExpired; else expired" class="loading-container">
    <mat-spinner color="primary" diameter="50"></mat-spinner>
    <p
      [translate]="paymentPendingDelayed ? 'SHARED.PAYMENT.PENDING.DELAYED_MESSAGE' : 'SHARED.PAYMENT.PENDING.MESSAGE'"
    ></p>
  </div>
  <ng-template #expired>
    <div>
      <p translate="SHARED.PAYMENT.PENDING.EXPIRED_MESSAGE"></p>
      <button
        mat-raised-button
        color="primary"
        translate="SHARED.PAYMENT.PENDING.BUTTON_LABEL"
        [mat-dialog-close]="true"
      ></button>
    </div>
  </ng-template>
</div>
